"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDatePickerPositioning = exports.useCalendarDates = void 0;
var react_1 = require("react");
var tools_1 = require("./tools");
var types_1 = require("./types");
var useCalendarDates = function (month, year) {
    if (month === void 0) { month = types_1.CUR_MONTH; }
    if (year === void 0) { year = types_1.CUR_YEAR; }
    var _a = (0, react_1.useState)((0, tools_1.generateCalendarDates)(month, year)), dates = _a[0], setDates = _a[1];
    (0, react_1.useEffect)(function () {
        setDates((0, tools_1.generateCalendarDates)(month, year));
    }, [month, year]);
    return dates;
};
exports.useCalendarDates = useCalendarDates;
var useDatePickerPositioning = function (inputRef, dropDownRef, open, parentRef, position) {
    var _a = (0, react_1.useState)({}), style = _a[0], setStyle = _a[1];
    (0, react_1.useEffect)(function () {
        var _a;
        if (!dropDownRef.current || !(inputRef === null || inputRef === void 0 ? void 0 : inputRef.current)) {
            return;
        }
        var toggleButtonCoords = inputRef.current.getBoundingClientRect();
        var menuCoords = dropDownRef.current.getBoundingClientRect();
        var windowHeight = window.innerHeight;
        var parentHeight = (_a = parentRef === null || parentRef === void 0 ? void 0 : parentRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight;
        var top = toggleButtonCoords.top + toggleButtonCoords.height;
        if (!position.top && !position.bottom) {
            position.bottom = true;
        }
        if (position.top) {
            top = -toggleButtonCoords.height * 0.5 - menuCoords.height;
        }
        else if (position.bottom) {
            top = '100%';
        }
        else {
            if (top + menuCoords.height > (parentHeight || windowHeight) &&
                toggleButtonCoords.top > menuCoords.height) {
                // top = 0 is half way the text input
                top = -toggleButtonCoords.height * 0.5 - menuCoords.height;
            }
            else {
                top = '100%';
            }
        }
        if (!position.left && !position.right) {
            position.left = true;
        }
        var left = position.left ? 0 : undefined;
        var right = position.right ? 0 : undefined;
        setStyle({ top: top, left: left, right: right });
    }, [dropDownRef, inputRef, open, parentRef]);
    return style;
};
exports.useDatePickerPositioning = useDatePickerPositioning;
